import { Star, ExternalLink, MessageCircle } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, CtaBand } from "@/components/blocks";
import { Reveal } from "@/components/Reveal";
import { COMPANY, wa, WA_MESSAGES } from "@/data/site";
import { track } from "@/lib/analytics";
import { breadcrumbJsonLd } from "@/lib/seo";

export default function Reviews() {
  return (
    <>
      <Seo
        title="Customer Reviews | Cherians Tech Solutions, Mallappally"
        siteName={COMPANY.brand}
        description="Read what customers of Cherians Tech Solutions, Mallappally have to say on Google, or leave CTS a review."
        jsonLd={breadcrumbJsonLd([{ label: "Reviews" }])}
      />
      <PageHero
        eyebrow="CUSTOMER REVIEWS"
        title="Reviews"
        intro="Our customers' experiences matter to us. Genuine CTS reviews live on Google — so you can always read them at the source."
        crumbs={[{ label: "Reviews" }]}
      />
      <section className="section-pad bg-white">
        <div className="container-site max-w-3xl">
          <Reveal>
            <div className="rounded-xl border border-cts-line bg-cts-soft p-8 md:p-10" data-testid="reviews-google-panel">
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex items-center justify-center w-11 h-11 rounded-md bg-white border border-cts-line">
                  <Star size={20} strokeWidth={1.75} className="text-cts-red" />
                </span>
                <h2 className="h3-display">Read CTS Reviews on Google</h2>
              </div>
              <p className="lead-text mb-6">
                We link directly to Google so you can read customer feedback at the original source.
              </p>
              <a
                href={COMPANY.googleSearch}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-view-google-btn"
                className="btn-outline"
              >
                <ExternalLink size={16} /> VIEW CTS ON GOOGLE
              </a>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="mt-8 rounded-xl border border-cts-line bg-white p-8 md:p-10 text-center" data-testid="reviews-leave-panel">
              <p className="eyebrow mb-2">YOUR EXPERIENCE MATTERS</p>
              <h2 className="h3-display mb-3">Worked With CTS?</h2>
              <p className="text-[15px] text-cts-charcoal max-w-md mx-auto leading-relaxed">
                We value honest feedback from our customers. A Google review helps other people in and
                around Mallappally find reliable technology support.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
                <a
                  href={COMPANY.googleSearch}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="reviews-page-google-btn"
                  className="btn-primary"
                >
                  LEAVE A GOOGLE REVIEW
                </a>
                <a
                  href={wa(WA_MESSAGES.general)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => track("whatsapp_click", { location: "reviews" })}
                  data-testid="reviews-whatsapp-btn"
                  className="btn-outline"
                >
                  <MessageCircle size={16} /> WHATSAPP US
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
